import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  drawerPaper: {
    width: '400px',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
  },
  titleContainer: {
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '1.1rem',
    letterSpacing: 1,
    fontWeight: 'bold',
  },
  menu: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
  },
  box: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'start',
    borderRadius: '8px',
    width: '45%',
    height: '90px',
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      height: '100px',
    },
  },
  ownerPhoto: {
    background: 'rgba(0,0,0,.5)',
    width: '100%',
    color: '#fff',
    textDecoration: 'underline',
  },
}));

export default useStyle;
